import styled from 'styled-components';

export const ProfileLink = styled.li`
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  display: inline-block;
  font-size: 18px;
`;

export const StyledLinka = styled.a`
  color: rgb(46, 204, 64);
  font-weight: bold;
`;